import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import content from '../data/content.json';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { navigation, company } = content;

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <nav className="nav-header">
        <div className="flex items-center">
          <Link to="/" className="flex items-center gap-2">
            <img
              src="/automation1st-logo.png"
              alt={company.name}
              className="h-8 w-auto"
            />
          </Link>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-1">
          {navigation.links.map((item) => (
            <Link
              key={item.label}
              to={item.href}
              className={`nav-link ${isActive(item.href) ? 'active' : ''}`}
            >
              {item.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-2">
          <Link to="/free-audit" className="btn-orange">
            {navigation.ctaButton}
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="fixed inset-0 z-40 bg-white pt-20 md:hidden">
          <div className="container">
            <div className="flex flex-col gap-4">
              {navigation.links.map((item) => (
                <Link
                  key={item.label}
                  to={item.href}
                  className={`nav-link ${isActive(item.href) ? 'active' : ''}`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
              <Link 
                to="/free-audit" 
                className="btn-orange mt-4"
                onClick={() => setIsMenuOpen(false)}
              >
                {navigation.ctaButton}
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navigation;
